import React from "react";
import { fromJS } from "immutable";

import useStoreState from "@/components/providers/useStoreState";
import ImageStore from "@/stores/ImageStore";
import DesignContextUtils from "@/utils/DesignContextUtils";

import styles from "./TemporaryCropImage.module.css";

/**
 * @typedef {Object} TemporaryCropImageProps
 * @property {"desktop" | "mobile"} layout
 * @property {import("immutable").Map<string, any>} designContext
 */

/** @param {TemporaryCropImageProps} props */
const TemporaryCropImage = ({ layout, designContext }) => {
  const cropState = useStoreState(ImageStore, ImageStore.getState);

  const { x, y, h, w, a } = ImageStore.getCurrentCrop(layout)?.toJS();

  const element = cropState.get("selectedElementData");

  const dimensions = { x, y, h, w, a };

  const { generateDesignAssetUrl } =
    DesignContextUtils.fromContext(designContext);
  const imageUrl = generateDesignAssetUrl({
    content: element.get("content"),
    elemProps: fromJS(dimensions).set("gs", element.getIn([layout, "gs"])),
  });

  return (
    <div
      className={styles["temp-crop-image"]}
      id={`temp-image-${layout}`}
      style={{
        backgroundImage: `url(${imageUrl})`,
        width: w,
        height: h,
        "--dimensions-x": x,
        "--dimensions-y": y,
        rotate: `${a}deg`,
      }}
    ></div>
  );
};

export default TemporaryCropImage;
